<template>
  <div v-if="OrderInfo.dataSource" class="confirm-order">
    <iHeader />
    <iNav :search="false" :car-btn="false" :phone="false" :title="false" content>
      <div slot="content" class="carName">
        <div class="cn">核对订单</div>
        <img style="width: 396px;" src="../../assets/buycar/step1.png">
      </div>
    </iNav>

    <!-- 商品信息 -->
    <div class="card">
      <div class="card-t">
        商品信息
        <span style="margin-left: 56px;" />
        <span style="margin-left: 400px;">单价</span>
        <span style="margin-left: 146px;">数量</span>
        <span style="margin-left: 134px;">小计</span>
        <span style="margin-left: 148px;">实付</span>
      </div>
      <div class="card-i" style="padding: 0;">
        <div
          class="pro-lst"
        >
          <van-image
            v-if="OrderInfo.dataSource.ImageUrl"
            width="160"
            height="80"
            :src="OrderInfo.dataSource.ImageUrl"
          />
          <div class="pro-content">
            <div class="gname">
              <div class="name-title ellips-text">
                {{ OrderInfo.dataSource.Name }}
              </div>
            </div>
            <div v-if="OrderInfo.dataSource.Value" class="gsize">
              价值：¥ {{ OrderInfo.dataSource.Value }}
            </div>
            <div class="gsize">
              限购数量：{{ OrderInfo.dataSource.LimitNum }}
            </div>
          </div>
          <div class="pro-col price-content">
            <!--  -->
            <p class="price ">￥{{ _moneyFormat(OrderInfo.dataSource.Price) }}</p>

          </div>
          <div class="pro-col">{{ OrderInfo.number }}</div>
          <div class="pro-col">
            ￥{{ _moneyFormat(OrderInfo.dataSource.Price * OrderInfo.number) }}
          </div>
          <div class="pro-col pro-total">
            ￥{{ _moneyFormat(OrderInfo.dataSource.Price * OrderInfo.number) }}
          </div>
        </div>
      </div>
    </div>
    <!-- 结算栏 -->
    <div class="submit">
      <!-- 操作面板 -->
      <div class="submit-c">
        <div style="font-weight: 500; color: rgba(17, 26, 52, 1);">
          已选择
          <span style="font-size: 16px; color: rgba(15, 110, 233, 1);">{{ OrderInfo.number }}</span>
          件商品<span v-if="OrderInfo.dataSource.Value"> ，价值：¥{{ _moneyFormat(OrderInfo.dataSource.Value) }}</span>
        </div>

        <div style="display: flex; align-items: center;">
          <div class="submit-total">
            <div class="submit-sum">
              应付：
              <span
                style="display: inline-flex; justify-content: center; align-items: center;"
              ><span style="margin-right: 6px; font-size: 20px;">¥</span><span class="fAvenirH" style="font-size: 28px;">{{ _moneyFormat(OrderInfo.dataSource.Price * OrderInfo.number) }}</span></span>
            </div>

            <div v-if="OrderInfo.dataSource.Subsidy" class="submit-maoli">平台补贴：¥{{ _moneyFormat(OrderInfo.dataSource.Subsidy) }}</div>
          </div>
          <div>
            <van-button class="submit-st" square color="#FF3939" @click="goPay()">
              <div> 立即购买 </div>
            </van-button>
          </div>
        </div>

      </div>
    </div>
    <!-- /结算栏 -->
    <iFooter />
  </div>
</template>

<script>
import iHeader from '@/components/Header'
import iFooter from '@/components/Footer'
import iNav from '@/components/Nav'
import { BaseMixin } from '../../mixins/BaseMixin'
import { LinkTypeCode } from '../../dictionary/base.js'
export default {
  name: 'BrokerageConfirmOrder',
  components: {
    iHeader,
    iFooter,
    iNav
  },
  mixins: [BaseMixin],
  data() {
    return {
      OrderInfo: {
        dataSource: null,
        number: 0
      },
      url: {
        getCreateOrderInfo: '/api_order/Orders/ConfirmOrderV2',
        createOrder: '/api_order/Orders/SubmitOrderV2',

        detail: '/api_coupon/CouponMall/CouponDetail'
      }

    }
  },
  async created() {
    const cusInfo = this.$auth.getCustomerOtherInfo()
    if (!cusInfo || !cusInfo.IsOrder) {
      this.$toast(cusInfo && cusInfo.NoOrderMsg ? cusInfo.NoOrderMsg : '暂时不能下单')

      this.$router.push(LinkTypeCode.Home)
      return
    }
    if (Object.keys(this.$route.params).length) {
      this.OrderInfo.number = this.$route.params.number
      this.getItemInfo(this.$route.params.dataSource.Id, this.$route.params.dataSource.SaleCouponsMgtId)
    } else {
      window.history.back()
    }
  },
  mounted() {

    // this.loadData();
  },
  methods: {
    // 获取券包详情
    async getItemInfo(id, SaleCouponsMgtId) {
      this.$hys.openLoading()
      const res = await this.getAction(this.url.detail, {
        from: 2,
        SaleCouponsMgtId,
        id
      })
      if (res.IsSuccess) {
        this.OrderInfo.dataSource = res.Data
      } else if (res.ErrorCode === 10001) {
        this.$toast(res.Msg)
        this.$router.back()
      } else {
        this.$toast(res.Msg)
        return
      }

      this.ableToShow = true
      this.$hys.clearLoading()
    },
    // 支付创建订单
    async goPay() {
      this.$router.push({
        name: 'BrokerageSelectPay',
        params: this.OrderInfo
      })
    }
  }
}
</script>

<style lang="less" scoped>
.submit-st {
  float: right;
  border-radius: 8px;
  width: 240px !important;
  height: 72px !important;
  font-size: 22px;
  color: #FFFFFF;
  background-color: #FF3939;
  line-height: 72px !important;
}

.card {
  margin: 30px auto 100px;
  border: 1px solid rgba(232, 232, 232, 1);
  width: 1200px;
  font-size: 14px;
  font-weight: 600;
  color: #222222;

  a {
    color: #0F6EEA;
  }

  &-t {
    padding-left: 20px;
    height: 50px;
    font-size: 16px;
    text-align: left;
    background-color: #F5F5F5;
    line-height: 50px;
    box-sizing: border-box;

    span {
      font-size: 16px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
    }
  }

  &-i {
    padding-top: 20px;
    padding-left: 20px;
    box-sizing: border-box;

    .img {
      margin: 10px 0 30px;
      width: 180px;
      height: 60px;
      cursor: pointer;
    }

    .revc-info-itm {
      position: relative;
      display: flex;
      align-items: center;
      margin-top: 10px;
      font-weight: 400;

      .left {
        width: 100px;
        text-align: left;
        color: #999999;
      }

      .right {
        margin-left: 10px;

        span {
          margin-right: 8px;
        }
      }

      .el-icon-arrow-right {
        margin-right: 10px;
        font-size: 20px;
      }

      .tips {
        position: absolute;
        top: 0;
        right: 5px;
        font-size: 12px;
        color: rgba(15, 110, 234, 1);
        line-height: 20px;

        > a:hover {
          color: #0F6EEA;
        }

        > a:link {
          color: #0F6EEA;
        }

        > a:visited {
          color: #0F6EEA;
        }
      }
    }

    .pro-lst {
      position: relative;
      display: flex;
      border-bottom: 2px rgba(224, 224, 224, .3) solid;
      padding: 30px 0 30px 20px;
      text-align: left;
      box-sizing: border-box;

      .img-overlay,
      span {
        position: absolute;
        bottom: 30px;
        left: 20px;
        width: 100px;
        height: 25px;
        font-size: 14px;
        text-align: center;
        color: #FFFFFF;
        line-height: 25px;
      }

      .img-overlay {
        background-color: #FF3939;
        opacity: .6;
      }

      .pro-content {
        padding-left: 25px;
        width: 291px;

        .gname {
          font-size: 14px;
          font-weight: 400;
          text-align: left;
          color: #222222;
        }

        .gsize {
          margin-top: 10px;
          font-size: 12px;
          font-weight: 400;
          text-align: left;
          color: #777777;
        }

        .name-title {
          flex: 1;
          font-weight: 700;
          color: #222222;
        }
      }

      .pro-col {
        margin-top: 25px;
        width: 175px;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
        color: #222222;
      }

      .pro-total {
        font-weight: 600;
        color: #FF3939;
      }

      &:last-child {
        border: none;
      }
    }

    .copun {
      border: 1px solid rgba(232, 232, 232, 1);
      width: 180px;
      height: 60px;
      font-size: 16px;
      text-align: center;
      color: rgba(153, 153, 153, 1);
      box-sizing: border-box;
      line-height: 60px;
      cursor: pointer;
    }

    .copun-sed {
      position: relative;
      height: 60px;
      text-align: center;
      color: #FF3939;
      background-size: 100%;
      line-height: 60px;

      > div {
        float: left;
        box-sizing: border-box;
      }

      .left {
        border: 1px #FF3939 solid;
        border-right: none;
        width: 140px;
        height: 60px;
        background-color: #FFE4E5;
      }

      .middle {
        width: 16px;
        height: 60px;
        background-image: url(../../assets/buycar/bg3.png);
      }

      .right {
        border: 1px #FF3939 solid;
        border-left: none;
        width: 71px;
        height: 60px;
        cursor: pointer;
      }
    }

    .copun-tip {
      margin-top: 20px;
      margin-bottom: 30px;
      font-size: 16px;
      color: #222222;
    }

    .order-price-itm {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 20px;
      font-size: 16px;
      font-weight: 400;

      .left {
        width: 100px;
        text-align: right;
        color: #999999;
      }

      .right {
        margin-left: 10px;
        padding-right: 20px;
        width: 300px;
        text-align: right;
        color: #FF3939;

        span {
          margin-right: 8px;
        }
      }
    }

    .coupons {
      display: flex;
      align-items: center;
      margin-top: 25px;
      min-height: 50px;
      background: rgba(255, 246, 216, 1);
      flex-wrap: wrap;

      .coupons-tag {
        margin-left: 20px;
        border-radius: 2px;
        padding: 2px 7px;
        font-size: 14px;
        color: rgba(255, 255, 255, 1);
        background:
          linear-gradient(
            166deg,
            rgba(255, 134, 57, 1) 0%,
            rgba(255, 71, 71, 1) 100%
          );
      }

      .coupons-content {
        margin-left: 24px;
        font-size: 16px;
        color: #D3691F;
      }
    }

    .submit {
      padding: 25px 20px;
      background-color: #F8F8F8;

      .submit-total {
        margin-right: 40px;
      }

      .money,
      .address {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        > div {
          font-weight: normal;

          > span {
            margin-left: 10px;

            &:first-child {
              margin-left: 0;
            }
          }

          &:first-child {
            width: 100px;
            text-align: right;
            color: #999999;
          }

          &:last-child {
            width: 300px;
            font-size: 26px;
            text-align: right;
            color: #FF3939;
          }
        }
      }

      .address {
        margin-top: 10px;

        > div {
          margin-left: 30px;
          font-size: 14px;
          text-align: right;
          color: #999999;

          &:first-child {
            margin-left: 30px;
            width: auto;
            font-size: 14px;
            color: #999999;
          }

          &:last-child {
            margin-left: 30px;
            width: auto;
            font-size: 14px;
            color: #999999;
          }
        }
      }
    }
  }

  &-f {
    margin-top: 30px;
    height: 3px;
    background-image: url(../../assets/buycar/bg1.png);
  }
}

.confirm-order {
  .submit {
    position: sticky;
    bottom: 0;
    height: 100px;
    color: #222222;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 -8px 12px 0 rgba(238, 238, 238, .5);
    transition: all .2s;
    box-sizing: border-box;

    .submit-c {
      width: 1200px;
    }

    .submit-sum {
      font-weight: bold;
    }

    .submit-total {
      margin-right: 24px;
    }

    &.show-shadow {
      border-top: 1px solid rgba(232, 232, 232, 1);
      height: 101px;
      box-shadow: 0 -8px 12px 0 rgba(238, 238, 238, .5);
    }

    &-c {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      padding-left: 21px;
      width: 1200px;
      height: 100px;
      font-size: 16px;
      box-sizing: border-box;
    }

    &-del {
      margin-left: 70px;
      cursor: pointer;
    }

    &-total {
      margin-left: 100px;
      text-align: left;
    }

    &-sum {
      font-size: 20px;
      color: rgba(34, 34, 34, 1);

      > span {
        font-size: 20px;
        font-weight: 600;
        color: rgba(255, 57, 57, 1);
      }
    }

    &-maoli {
      margin-top: 5px;
      font-size: 16px;
      color: rgba(34, 34, 34, 1);
    }

    &-st {
      float: right;
      width: 250px;
      height: 100px;
      font-size: 22px;
      color: #FFFFFF;
      background-color: #FF3939;
      line-height: 100px;

      span {
        display: flex;
        flex-direction: column;

        > div {
          line-height: initial;
        }
      }
    }
  }
}

</style>
